import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    Container: {
        padding: "5px",
    },
    headerAction: {
        textAlign: 'right',
    },

    changeBtn: {
        fontSize: '14px',
        color: '#ffffff !important',
        fontWeight: '400 !important',
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '6px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        cursor: 'pointer',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },
    organizationDiscription: {
        fontFamily: "Lato",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "17px",
        letterSpacing: "0em",
        textAlign: "left",
    },
    longDesc: {
        "& p": {
            fontFamily: "Lato",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "17px",
            letterSpacing: "0em",
            textAlign: "left",
        }
    }
}))